import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path, Rect } from "react-native-svg";

export const IconDistortion: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconDistortion"><Rect x="3.5" y="3.5" width="17" height="17" stroke="currentColor"/><Path d="M12 3.5C17.1962 10.8681 6.80385 13.1319 12 20.5" stroke="currentColor"/><Path d="M3.5 12C10.8681 6.80385 13.1319 17.1962 20.5 12" stroke="currentColor"/></CentralIconBase>;
});

export default IconDistortion;
